import { useEffect } from 'react'

import { initializeYandexMetrika } from './yandex-metrika'

export function YandexMetrika() {
  useEffect(() => {
    initializeYandexMetrika()
  }, [])

  return null
}
